<template>
  <base-dblclick-input
    modelType="contact"
    :model-id="companyContact.id"
    field-name="last_name"
    :field-value="companyContact.last_name"
    inputType="text"
    @refetch="fetchNewCompanies"
  ></base-dblclick-input>
</template>

<script>
  export default {
      name: "company-contact-last-name-cell"
  }

</script>

<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      companyContact: Object
  })

  const emit = defineEmits(['refetch-companies'])

  function fetchNewCompanies () {
      emit('refetch-companies')
  }

</script>